<template>
  <router-view />
</template>

<script lang="ts" setup>

import { onMounted } from 'vue';
import { useRouter } from "vue-router";
import { loginStore } from '@/stores/login'

onMounted(() => {
  const MILLISECONDS = 1000;
  const store = loginStore();
  let payload = store.tokenPayload;
  const nowTimestamp = Math.trunc(Date.now() / MILLISECONDS);
  if (payload && nowTimestamp >= payload["exp"]) {
    const router = useRouter();
    localStorage.removeItem('JWT');
    router.go();
  }
})
</script>